<script async setup>
import { useSEO } from '~/composables/seo'

const route = useRoute()

const showData = ref([])
const contestantData = ref([])

// console.log('route is:', route.params.year)
const { data, error } = await useFetch(`/api/shows?year=${route.params.year}`, { key: `shows_${route.params.year}` },
)

if (error.value) {
  // console.log('error is11', error.value)
  throw createError({ statusCode: 404 })
}

showData.value = data.value.shows
contestantData.value = data.value.contestants

const { GenerateTags } = useSEO()
GenerateTags({ title: `📺 ${route.params.year} shows`, desc: `List of OTB Crappy Quiz shows in ${route.params.year}` })

definePageMeta({ scrollToTop: true })
</script>

<template>
  <div>
    <TheShowNav />
    <div class="pl-4 sm:pl-10 py-6">
      <div class="flex items-center sg-semibold dark:text-gray-50">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          aria-hidden="true"
          role="img"
          class="-rotate-10 h-9 w-9"
          width="32"
          height="32"
          preserveAspectRatio="xMidYMid meet"
          viewBox="0 0 48 48"
        ><g fill="none" stroke-linejoin="round" stroke-width="4">
          <path fill="#2F88FF" stroke="#000 dark:gray-50" d="M42 12H6C4.89543 12 4 12.8954 4 14V40C4 41.1046 4.89543 42 6 42H42C43.1046 42 44 41.1046 44 40V14C44 12.8954 43.1046 12 42 12Z" />
          <path fill="#43CCF8" stroke="#fff" d="M31 19H11V35H31V19Z" />
          <path stroke="#000 dark:gray-50" stroke-linecap="round" d="M14 4.5L23.0909 12L34 2" />
          <path stroke="#fff" stroke-linecap="round" d="M38 18V19" /><path stroke="#fff" stroke-linecap="round" d="M38 25V26" /></g></svg>
        <span class="pl-2">Click show title to view episode</span>
      </div>
    </div>
    <TheShowList :contestants="contestantData" :data="showData" />
  </div>
</template>
